import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "favorites",
  "use": "favorites-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"favorites\"><path d=\"M3 2v11.5l6 3 6-3V2zm7.4 8.43L9 9.69l-1.4.74.27-1.56-1.14-1.11 1.57-.22.7-1.42.7 1.42 1.57.23-1.13 1.11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol